package com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui

import androidx.compose.runtime.Stable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.setValue

@Stable
class BookmarkScrollController {
    var currentScrollY by mutableIntStateOf(0)

    /** Where the top line of the screen starts in the text: unlike the pixels, it holds at any width. */
    var currentTextOffset by mutableIntStateOf(-1)
}
